module.exports = {
  serverUrl: process.env.NODE_ENV === 'production' ? 'https://www.aeroport-iasi.ro:5000' : 'http://localhost:5000',
  refreshInterval: 60000,
  alertRefreshInterval: 15000,
  tvPageRefreshInterval: 900000,
  flightBuffer: 300000 * 6,
  countries: [
    { "name": "AMSTERDAM", "code": "AMSTERDAM" },
    { "name": "FRANKFURT", "code": "FRANKFURT" },
    { "name": "BERLIN", "code": "BERLIN" },
    { "name": "MADRID", "code": "MADRID" },
    { "name": "LISABONA", "code": "LISABONA" },
    { "name": "DUBLIN", "code": "DUBLIN" },
    { "name": "LIVERPOOL", "code": "LIVERPOOL" },
    { "name": "GLASGOW", "code": "GLASGOW" },
    { "name": "ATENA", "code": "ATENA" },
    { "name": "ISTANBUL", "code": "ISTANBUL" },
    { "name": "VALENCIA", "code": "VALENCIA" },
    { "name": "FLORENTA", "code": "FLORENTA" },
    { "name": "PRAGA", "code": "PRAGA" },
    { "name": "STOCKHOLM", "code": "STOCKHOLM" },
    { "name": "COPENHAGA", "code": "COPENHAGA" },
    { "name": "NISA", "code": "NISA" },
    { "name": "LYON", "code": "LYON" },
    { "name": "DUBAI", "code": "DUBAI" },
    { "name": "VARSOVIA", "code": "VARSOVIA" },
    { "name": "BUDAPESTA", "code": "BUDAPESTA" },
    { "name": "MALAGA", "code": "MALAGA" },
    { "name": "BARI", "code": "BARI" },
    { "name": "CLUJ-NAPOCA", "code": "CLUJ-NAPOCA" },
    { "name": "TIMISOARA", "code": "TIMISOARA" },
    { "name": "CONSTANTA", "code": "CONSTANTA" },
    { "name": "ORADEA", "code": "ORADEA" }
  ]
};



// WEBPACK FOOTER //
// ./src/config/index.js